import React from 'react'
import Grid from '../commonComponents/Grid';

function GridParentReport({ renderData, handleRightClickOption, moreOptions, subMenuOptions, handleBreakdown, setDataFunction, handleFavourite, handleArchive }) {
    let dataLoop = {};
    let dashboardSectionNames = {};

    renderData.map((eachValue, index) => {
        let loopKey = eachValue.dashboard_group
        if (dashboardSectionNames[loopKey] == undefined) {
            dashboardSectionNames[loopKey] = {
                dashboard_group: eachValue.dashboard_group,
            }
            dataLoop[loopKey] = [];
        }
        dataLoop[loopKey].push(
            <Grid
                id={`report_${eachValue.dashboard_id || eachValue.report_id}`}
                key={`report_${eachValue.dashboard_id || eachValue.report_id}_${index}`}
                icon='file-text'
                title={eachValue.reportName ? eachValue.reportName : '-'}
                mediaBodyId={`reportId_${eachValue.dashboard_id || eachValue.report_id}`}
                folderDetails={eachValue}
                datasetFolderEvent={handleRightClickOption}
                description={eachValue.dashboard_group}
                additionalDescription={eachValue.datasetName}
                lastTime={eachValue.dateModified}
                moreOptions={moreOptions}
                subMenuOptions={subMenuOptions}
                eventMore={handleBreakdown}
                stateChange={true}
                openDataSet={setDataFunction}
                handleFavourite={handleFavourite}
                handleArchive={handleArchive}
            />
        );
    });
    return (
        <div className="w-100">
            {Object.keys(dashboardSectionNames).map(function (dashboard) {
                return (<>
                    <label className="d-block tx-medium tx-10 tx-uppercase tx-sans tx-spacing-1 tx-color-03 mg-t-15 mg-b-0  " style={{ fontSize: "13px", color: 'black', fontWeight: "bold" }} key={`individualLabel_${dashboard}`}>
                        {`${dashboardSectionNames[dashboard].dashboard_group}`}
                    </label>
                    <div className="row row-xs" key={`individualRow_${dashboard}`}>
                        {dataLoop[dashboard]}
                    </div>
                    <hr style={{ borderTop: "2px solid #E2E5ED" }} />
                </>)
            })}
        </div>
    )
}

export default GridParentReport